import {useTranslation} from "react-i18next";
import DateDisplay from "components/datetime/DateDisplay";
import ConditionalRender from "components/ConditionalRender";

const PrevTasks = ({item, showPreview}) => {
    const {t: _Tt} = useTranslation("tables");
    const {t: _Tc} = useTranslation("choices");

    if (!item || Object.keys(item).length === 0) {
        return null;
    }

    const programmingLabel = () => {
        if (item.programming_is_periodic) {
            return `${item.programming_every || ''} ${item.programming_repeat || ''}`.trim();
        }
        return item.programming_id ? _Tt('tasks.programmed') : _Tt('tasks.manual');
    };

    return (
        <div className={`col preview-row ${showPreview ? "" : "d-none"}`} style={{width: "300px", maxWidth: "300px"}}>
            <div className="row">
                <div className="col-12 p-0">
                    <div className="preview-card" style={{width: "300px"}}>
                        <div className="preview-header">
                            <div className="preview-title">
                                <label>{_Tt('tasks.name')}</label>
                                <div>{item.name}</div>
                            </div>
                        </div>

                        <div className="preview-item">
                            <label>{_Tt('common.description')}</label>
                            <div className="preview-input">{item.description || '-'}</div>
                        </div>

                        <div className="preview-item">
                            <label>{_Tt('tasks.type')}</label>
                            <div className="preview-input">{_Tc("tasks." + item.type) || '-'}</div>
                        </div>

                        <div className="preview-item">
                            <label>{_Tt('tasks.type')}</label>
                            <div className="preview-input">{programmingLabel()}</div>
                        </div>

                        <div className="preview-item">
                            <label>{_Tt('common.created_at')}</label>
                            <div className="preview-input"><DateDisplay date={item.created_at} title={false} /></div>
                        </div>

                        <div className="preview-item">
                            <label>{_Tt('common.created_by')}</label>
                            <div className="preview-input">{item.created_by__email || '-'}</div>
                        </div>
                        <div className="preview-item">
                            <label>{_Tt('common.destination_email')}</label>
                            <div className="preview-input" style={{whiteSpace: 'pre-line'}}>
                                {item.leader_email || '-'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrevTasks;
